import React from 'react';
import { PhoneCountryCodeType } from '@bus/models';
import { createOptionsList } from '../../../../services/common/miscUtils';
import { getMaxBirthDate, getMinBirthDate } from '../../../../services/common/validation';
import { GenderEnum, ResidentialStatusEnum, TitleEnum } from '../../../../types/forms';
import { DatePickerFormField } from '../../../Fieldset/DatePickerFormField';
import { PhoneNumberFormField } from '../../../Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../../Fieldset/TextInputFormField';
import { buildFieldName } from '../../../../utils/fieldNameUtils';

export const createFormInputs = (formTranslationKey: string, disabled = false, fieldNamePrefix?: string) => {
  return {
    title: () => (
      <SelectFormField
        fieldName={buildFieldName('title', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:title:label`}
        optionList={createOptionsList(TitleEnum, formTranslationKey, 'title')}
        isDisabled={disabled}
      />
    ),
    firstName: () => (
      <TextInputFormField
        fieldName={buildFieldName('firstName', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:firstName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:firstName:placeholder`}
        isDisabled={disabled}
      />
    ),
    middleName: () => (
      <TextInputFormField
        fieldName={buildFieldName('middleName', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:middleName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:middleName:placeholder`}
        isDisabled={disabled}
        optional
      />
    ),
    lastName: () => (
      <TextInputFormField
        fieldName={buildFieldName('lastName', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:lastName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:lastName:placeholder`}
        isDisabled={disabled}
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName={buildFieldName('email', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:email:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:email:placeholder`}
        isDisabled={disabled}
      />
    ),
    gender: () => (
      <SelectFormField
        fieldName={buildFieldName('gender', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:gender:label`}
        optionList={createOptionsList(GenderEnum, formTranslationKey, 'gender')}
        isDisabled={disabled}
      />
    ),
    dateOfBirth: () => (
      <DatePickerFormField
        fieldName={buildFieldName('dateOfBirth', fieldNamePrefix)}
        labelTranslationKey="contactDetailsForm:fields:dateOfBirth:label"
        placeholderTranslationKey="contactDetailsForm:fields:dateOfBirth:placeholder"
        maxDate={getMaxBirthDate()}
        minDate={getMinBirthDate()}
        isDisabled={disabled}
      />
    ),
    countryCode: () => (
      <SelectFormField
        fieldName={buildFieldName('countryCode', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:countryCode:label`}
        optionList={createOptionsList(PhoneCountryCodeType, formTranslationKey, 'countryCode')}
        isDisabled={disabled}
      />
    ),
    mobileNumber: () => (
      <PhoneNumberFormField
        fieldName={buildFieldName('mobileNumber', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:mobileNumber:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:mobileNumber:placeholder`}
        isDisabled={disabled}
        type="mobile"
      />
    ),
    residentialStatus: () => (
      <SelectFormField
        fieldName={buildFieldName('residentialStatus', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:residentialStatus:label`}
        optionList={createOptionsList(ResidentialStatusEnum, formTranslationKey, 'residentialStatus')}
        isDisabled={disabled}
      />
    ),
  };
};
